"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackNavigator = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ModalNavigator_1 = require("./ModalNavigator");
const StackNavigator = (props) => {
    const { mode, children } = props;
    if (mode === 'modal') {
        return react_1.default.createElement(ModalNavigator_1.ModalNavigator, Object.assign({}, props));
    }
    return children;
};
exports.StackNavigator = StackNavigator;
exports.StackNavigator.displayName = 'StackNavigator';
